<div class="xp-review__meta">
	<div class="xp-review__rating">
		<ng-content select="[xpReviewStars]"></ng-content>
		<span class="xp-review__score">{{ score() }}</span>
	</div>
	<span class="xp-review__date">{{ date() }}</span>
</div>
<div class="xp-review__text">{{ text() }}</div>
<ng-content></ng-content>
